// src/components/Onboarding/UserRegister/AgentLiketoStartModal.js
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { hideAgentPreferenceModal } from "@/reducers/ui";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Button } from "react-bootstrap";
import {
  PROPERTY_AD,
  USER_INFO_KEY,
  USER_TYPE_AGENT,
  WANT_AD,
} from "../../../constants/common";
import {
  getLocalStorage,
  setLocalStorage,
  checkTutorialDisplayStatus,
} from "@/helpers/common";
import { themeColors } from "../../../themeColors";
import { pageURLs } from "@/constants";
import { useNavigate } from "react-router-dom";

const AgentLiketoStartModal = ({ backClick }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const show = useSelector((state) => state.ui.agentPreferenceModal);

  const [agentPreference, setAgentPreference] = useState(null);

  let DisplayWantAddOnboard = checkTutorialDisplayStatus(6);
  let DisplayInventoryAddOnboard = checkTutorialDisplayStatus(7);

  const userDetails = getLocalStorage(USER_INFO_KEY);
  const userType = _.get(userDetails, "userInfo.userType", null);

  const preferenceSelection = (e) => setAgentPreference(e.target.value);

  const handleContinue = (clickedButton) => {
    if (clickedButton === "Continue") {
      setLocalStorage("tutorialOnSignUp", 1);

      if (agentPreference === WANT_AD) {
        DisplayWantAddOnboard
          ? navigate(pageURLs.gitchaMemberWelcome)
          : navigate(pageURLs.agentCreatewantad);
      } else {
        DisplayInventoryAddOnboard
          ? navigate(pageURLs.gitchaInvetoryOnBoard)
          : navigate(pageURLs.agentCreateInventory);
      }
      dispatch(hideAgentPreferenceModal());
    } else {
      dispatch(hideAgentPreferenceModal());
      if (typeof backClick === "function") backClick();
      navigate(pageURLs.home);
    }
  };

  const closeAndBack = () => handleContinue("browse_feed");

  return (
    <Modal
      show={show}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="mw-548"
    >
      <Modal.Body className="pt-32 pb-32">
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={closeAndBack}
        />

        <h3 className="text-start pt-3">How would you like to start?</h3>

        <Row>
          <Col xl={12}>
            <p className="mb-32 text-start f-size-16">
              To begin, select whether you would like to create a want-listing
              or save a property.
            </p>

            <div className="wantad-timing-wrap pb-2">
              <label className="radio-wrap mb-4">
                <input
                  type="radio"
                  name="radio"
                  value={WANT_AD}
                  checked={agentPreference === WANT_AD}
                  onClick={preferenceSelection}
                />
                <span>
                  <div className="timing-wrap-info">
                    <h2 className="pb-1">Create a want-listing</h2>
                    <p>
                      {userType === USER_TYPE_AGENT
                        ? "You have a client who is looking to buy, rent, or stay in a property. You want to share what they’re looking for to receive introductions from people with matching property."
                        : "You’re looking to buy, rent, or stay in a property. You want to share what you’re looking for to receive introductions from people with matching property."}
                    </p>
                  </div>
                </span>
              </label>

              <label className="radio-wrap mb-4">
                <input
                  type="radio"
                  name="radio"
                  value={PROPERTY_AD}
                  checked={agentPreference === PROPERTY_AD}
                  onClick={preferenceSelection}
                />
                <span>
                  <div className="timing-wrap-info">
                    <h2 className="pb-1">Save property to your inventory</h2>
                    <p>
                      {userType === USER_TYPE_AGENT
                        ? "You have a client who has a property they’re considering selling or renting-out (long or short-term). You want to gauge demand or send a preview of their property to matching want-listings."
                        : "You own a property you’re considering selling or renting-out (long or short-term). You want to gauge demand or send a preview of your property to matching want-listings."}
                    </p>
                  </div>
                </span>
              </label>
            </div>

            <div className="modal-btn-wrap flex-column">
              <Button
                variant="primary"
                className="btn w-100 l-spacing-0"
                disabled={!agentPreference}
                onClick={() => handleContinue("Continue")}
              >
                Continue
              </Button>

              <a
                role="button"
                href={void 0}
                className="bottom-back-btn d-inline-block mt-4 mx-auto"
                onClick={closeAndBack}
              >
                Browse Want-Listing Feed
                <span className="right-arrow">
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9.76661 3.59982C9.96187 3.40455 10.2785 3.40455 10.4737 3.59982L14.5204 7.64648C14.6142 7.74025 14.6668 7.86743 14.6668 8.00004C14.6668 8.13264 14.6142 8.25982 14.5204 8.35359L10.4737 12.4003C10.2785 12.5955 9.96187 12.5955 9.76661 12.4003C9.57135 12.205 9.57135 11.8884 9.76661 11.6931L12.9597 8.50004H2.8335C2.55735 8.50004 2.3335 8.27618 2.3335 8.00004C2.3335 7.72389 2.55735 7.50004 2.8335 7.50004H12.9597L9.76661 4.30692C9.57135 4.11166 9.57135 3.79508 9.76661 3.59982Z"
                      fill={themeColors.primary250}
                    />
                  </svg>
                </span>
              </a>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default AgentLiketoStartModal;
